/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import Body from "ui/kit/typography/Body";

const LoadingSection: React.FC = () => {
    return <Body>Loading...</Body>
};

export default LoadingSection;
